/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EloshieldModule } from './EloshieldModule';
import {
    EloshieldModuleFromJSON,
    EloshieldModuleFromJSONTyped,
    EloshieldModuleToJSON,
    EloshieldModuleToJSONTyped,
} from './EloshieldModule';

/**
 * 
 * @export
 * @interface ActionTemplate
 */
export interface ActionTemplate {
    /**
     * 
     * @type {string}
     * @memberof ActionTemplate
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ActionTemplate
     */
    label: string;
    /**
     * 
     * @type {any}
     * @memberof ActionTemplate
     */
    nodes: any | null;
    /**
     * 
     * @type {any}
     * @memberof ActionTemplate
     */
    edges: any | null;
    /**
     * 
     * @type {EloshieldModule}
     * @memberof ActionTemplate
     */
    eloshieldModule: EloshieldModule;
}



/**
 * Check if a given object implements the ActionTemplate interface.
 */
export function instanceOfActionTemplate(value: object): value is ActionTemplate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('nodes' in value) || value['nodes'] === undefined) return false;
    if (!('edges' in value) || value['edges'] === undefined) return false;
    if (!('eloshieldModule' in value) || value['eloshieldModule'] === undefined) return false;
    return true;
}

export function ActionTemplateFromJSON(json: any): ActionTemplate {
    return ActionTemplateFromJSONTyped(json, false);
}

export function ActionTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'nodes': json['nodes'],
        'edges': json['edges'],
        'eloshieldModule': EloshieldModuleFromJSON(json['eloshieldModule']),
    };
}

export function ActionTemplateToJSON(json: any): ActionTemplate {
    return ActionTemplateToJSONTyped(json, false);
}

export function ActionTemplateToJSONTyped(value?: ActionTemplate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'nodes': value['nodes'],
        'edges': value['edges'],
        'eloshieldModule': EloshieldModuleToJSON(value['eloshieldModule']),
    };
}

